import { Inject, Injectable } from '@angular/core';
import { ConfirmDialogComponent } from '@shared/dialogs/confirm-dialog/confirm-dialog.component';
import { DialogService } from '@shared/services/dialog.service';
import { TRANSLATOR, Translator } from '@miq/utils';

@Injectable({
  providedIn: 'root',
})
export class DeactiveDialogService {
  private showCancelButton = true;
  private swap = true;
  private showCloseButton = true;

  constructor(
    private notificationService: DialogService,
    @Inject(TRANSLATOR) private translationService: Translator
  ) {}
  showDialog(message?: string, confirmText?: string, cancelText?: string, leaveMessage?: string, translate?: boolean) {
    let cancelTextToDisplay: string = undefined;
    if (this.showCancelButton) {
      cancelTextToDisplay = cancelText ? cancelText : this.translationService.translate('shared.leave');
    }
    const data = {
      message: message ? message : this.translationService.translate('shared.youHaveUnsavedChanges'),
      confirmText: confirmText ? confirmText : this.translationService.translate('shared.stay'),
      cancelText: cancelTextToDisplay,
      swap: this.swap,
      leaveMessage: leaveMessage ? leaveMessage : this.translationService.translate('shared.clickStayAndHitSave'),
      showCloseButton: this.showCloseButton,
      translate,
    };
    return this.notificationService.openDialog(ConfirmDialogComponent, data);
  }

  public setShowCancelButton(isShowCancelButton: boolean): DeactiveDialogService {
    this.showCancelButton = isShowCancelButton;
    return this;
  }
  public setSwap(isSwap: boolean): DeactiveDialogService {
    this.swap = isSwap;
    return this;
  }
  public setShowCloseButton(isShowCloseButton: boolean): DeactiveDialogService {
    this.showCloseButton = isShowCloseButton;
    return this;
  }
}
